const getEnvColor = (type) => {
    switch (type) {
        case "DEPARTMENT_STORE":
            return "#FF5252"; //Red-A200
        case "MARKET":
            return "#FFD740"; //Amber-A200
        case "HOSPITAL":
            return "#1DE9B6"; // Teal-A400
        case "STARBUCKS":
            return "#00C853"; // Green-A700
        case "CUSTOM":
            return "#EA80FC"; // Purble-A100
        default:
            return "#fff";
    }
};

const Color = {
    green: "#1B5E20",
    green2: "teal",
    yellow: "#FFD600",
    red: "#B71C1C"
};

const getEnvMarker = (data) => {
    if (!data || !data.type)
        return null;

    switch (data.type) {
        case "DEPARTMENT_STORE":
            return {
                content: [
                    `<div style="z-index:4;position:relative;left:-50%;font-size:15px;color:#fff;background:${Color.red};padding:4px 12px;">${data.name}</div>`
                ].join("")
            };
        case "MARKET":
            return {
                content: [
                    `<div style="z-index:3;position:relative;left:-50%;font-size:15px;color:#000;background:${Color.yellow};padding:4px 12px;">${data.name}</div>`
                ].join("")
            };
        case "HOSPITAL":
            return {
                content: [
                    `<div style="z-index:2;position:relative;left:-50%;font-size:15px;color:#fff;background:${Color.green2};padding:4px 12px;">${data.name}</div>`
                ].join("")
            };
        case "STARBUCKS":
            return {
                content: [
                    `<div style="z-index:1;position:absolute;left:-16px;top:-16px;">`,
                    `<img src="https://www.starbucks.co.kr/common/img/common/logo.png" width="32" height="32"/>`,
                    `</div>`
                ].join("")
            };
        case "CUSTOM":
            return {
                content: [
                    `<div style="z-index:3;position:relative;left:-50%;font-size:15px;color:#000;background:#ccc;padding:4px 12px;">${data.name}</div>`
                ].join("")
            };
        case "UNKNOWN":
            return {
                content: [`<div>${data.name}</div>`].join("")
            };
        default:
            return null;
    }
};

export { getEnvColor, getEnvMarker };
